var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShieldIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 32,
    viewBox: "0 0 26 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0643 2.71211C12.439 2.55133 12.8633 2.55133 13.238 2.71211L22.2923 6.59712C22.8392 6.8318 23.1938 7.36974 23.1938 7.96494V14.5455C23.1938 20.9452 18.5587 27.5497 13.1001 29.5599C12.8101 29.6667 12.4922 29.6667 12.2022 29.5599C6.74368 27.5497 2.10852 20.9452 2.10852 14.5455V7.96494C2.10852 7.36974 2.46308 6.8318 3.01001 6.59712L12.0643 2.71211ZM13.2731 0.285987C12.8784 0.10446 12.424 0.10446 12.0292 0.285987L0.866493 5.41968C0.33839 5.66254 0 6.19063 0 6.7719V14.5455C0 22.4827 5.21817 29.9137 12.2876 31.9029C12.5252 31.9698 12.7772 31.9698 13.0148 31.9029C20.0842 29.9137 25.3023 22.4827 25.3023 14.5455V6.7719C25.3023 6.19063 24.9639 5.66254 24.4359 5.41968L13.2731 0.285987Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3913 18.872C10.1016 19.1574 9.63623 19.1574 9.34652 18.872L6.69053 16.2544C6.40081 15.9688 5.93551 15.9688 5.64579 16.2544L5.4724 16.4252C5.17664 16.7167 5.17664 17.1938 5.4724 17.4853L9.34652 21.3034C9.63623 21.5889 10.1016 21.5889 10.3913 21.3034L19.9047 11.9277C20.2004 11.6362 20.2004 11.1591 19.9047 10.8676L19.7313 10.6967C19.4416 10.4112 18.9762 10.4112 18.6865 10.6967L10.3913 18.872Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldIcon);
export default __webpack_public_path__ + "static/media/shield-icon.b7d3b3fd821b7512427558cb3e85ae9d.svg";
export { ForwardRef as ReactComponent };